import { generateHeader, DELETEAPI } from "src/api-setup/api-helper";
import { DELETE_TIMESHEET } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../utils/constants";
import { setNewMessage } from "src/redux/actions/setting-actions";

export const deleteTimesheet = async (cookiesData, dispatch, timesheetMstrKey) => {
  if (!cookiesData || !timesheetMstrKey) return null;

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_timesheet_mstr_key: [{ id: timesheetMstrKey }],
      in_version: null,
    };

    const response = await DELETEAPI(false, DELETE_TIMESHEET, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.out_parameters.out_ret_code === API_CONSTANTS.SUCCESS_CODE) {
      dispatch(setNewMessage({ message: "Timesheet deleted successfully", type: "Success", show: true }));
      return {
        status: true,
        message: "Timesheet deleted successfully",
      };
    } else {
      dispatch(setNewMessage({ message: "Error deleting timesheet", type: "Error", show: true }));
      return {
        status: false,
        message: "Error deleting timesheet: " + (response.data.out_parameters.out_error_msg || "Unknown error"),
      };
    }
  } catch (error) {
    console.error("Error deleting timesheet:", error);
    return {
      status: false,
      message: "Error deleting timesheet: " + (error.message || "Unknown error"),
    };
  }
};
